// extracted by mini-css-extract-plugin
export default {"iconDefault":"_2-jv1"};